module.exports = __webpack_public_path__ + "img/ml.bc4af821.svg";